<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M6,10C4.9,10,4,9.1,4,8C4,8,4,3,4,3C4,3,1,3,1,3C0.45,3,0,3.45,0,4C0,4,0,12,0,12C0,12.55,0.45,13,1,13C1,13,1,15,1,15C1,15.55,1.45,16,2,16C2.28,16,2.53,15.89,2.71,15.71C2.71,15.71,5.41,13,5.41,13C5.41,13,10,13,10,13C10.55,13,11,12.55,11,12C11,12,11,10.83,11,10.83C11,10.83,10.17,10,10.17,10C10.17,10,6,10,6,10C6,10,6,10,6,10ZM15,0C15,0,6,0,6,0C5.45,0,5,0.45,5,1C5,1,5,8,5,8C5,8.55,5.45,9,6,9C6,9,10.59,9,10.59,9C10.59,9,13.3,11.71,13.3,11.71C13.47,11.89,13.72,12,14,12C14.55,12,15,11.55,15,11C15,11,15,9,15,9C15.55,9,16,8.55,16,8C16,8,16,1,16,1C16,0.45,15.55,0,15,0C15,0,15,0,15,0Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Chat',
} as DefineComponent
</script>
